import React from "react";
import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { MDXRemote } from "next-mdx-remote";

import importAll from "../../../lib/utils/image";
import CloudinaryImage from "../../Common/CloudinaryImage";

const OurStory = ({ content }) => {
  const { t } = useTranslation("about");
  const allImages = importAll(
    require.context(
      "../../../public/static/images/about/our_story",
      false,
      /\.(png|jpe?g|svg|webp)$/
    )
  );
  const components = {
    a: (props) => <Link target="_blank" {...props} />,
  };
  const partners = [
    {
      fileName: "BPI-France.png",
      name: "BPI France",
    },
    {
      fileName: "ce-logo-normandie.png",
      name: "Caisse d'Epargne Normandie",
    },
    {
      fileName: "fiance-brussels.png",
      name: "Finance Brussels",
    },
    {
      fileName: "MIT.png",
      name: "MIT Technology Review",
    },
    {
      fileName: "Region-IDF.png",
      name: "Région Île de France",
    },
    {
      fileName: "tedxparis-logo.png",
      name: "TEDx Paris",
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: "medium",
          }}
          gutterBottom
          color={"textSecondary"}
          align={"center"}
        >
          {t("our_story.title")}
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant={"h3"}
          gutterBottom
          align={"center"}
        >
          {t("our_story.subtitle")}
        </Box>
        <Typography
          variant={"h6"}
          component={"p"}
          color={"textSecondary"}
          align={"center"}
        >
          <MDXRemote components={components} {...content} />
        </Typography>
      </Box>
      <Box marginTop={8} marginBottom={5}>
        <Box display="flex" flexWrap="wrap" justifyContent={"center"}>
          {partners.map((item, i) => (
            <Box marginTop={2} marginRight={7} key={i}>
              <CloudinaryImage
                src={allImages[item.fileName]}
                alt={`Photo ${item.name}`}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default OurStory;
